import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase-config';
// Components
import PageTransition from '../components/PageTransition';
// CSS
import '../assets/css/enroll.css'

export default function Enroll() {
  const [userData, setUserData] = useState({facebookLink: '', mobileNumber: '', email: ''});
  const [courseData, setCourseData] = useState(({banner: {type: null}}))
  const { courseId } = useParams();

  useEffect(() => {
    localStorage.removeItem('login_redirect_url');
  }, []);
  
  useEffect(() => {
    var userDatas = JSON.parse(localStorage.getItem('user_data'));
    var enrollCourseData = JSON.parse(localStorage.getItem('enroll_course_data'));

    if(userDatas){
      setUserData(userDatas);
    }
    else{
      getDoc(doc(db, 'Users', auth.currentUser.uid)).then((doc) => {
        setUserData(doc.data().data);
      })
    }

    if(enrollCourseData){
      setCourseData(enrollCourseData)
    }
    else{
      getDoc(doc(db, 'Courses', courseId)).then((doc) => {
        setCourseData(doc.data().data)
      })
    }
  }, []);

  return (
    <div className='enroll_page page_body'>
      <PageTransition />

      <div className='container'>
        <div className='header'>
          <div className='course_banner'>
            {
              courseData.banner.type === null?
              <img src={require('../assets/gifs/media-loading.gif')} alt=""/>
              :
              courseData.banner.type === 'image'?
              <img src={courseData.banner.address} alt="Course Banner" />
              :
              courseData.banner.type === 'video'?
              <video src={courseData.banner.address} controls controlsList="nodownload" autoPlay />
              :
              courseData.banner.type === 'iframe'?
              <iframe width="560" height="315" src={courseData.banner.address} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
              :<></>
            }
          </div>
          <div className='title'><span className='underline'>প্রফেশনাল</span> {courseData.name} <span className='batch'>{courseData.batch != false? 'Batch: '+courseData.batch : ''}</span></div>
        </div>

        <section className='contact_infos'>
          <div className='section_title_default' style={{display: 'inline-block !important'}}>Contact Infos</div>
          <div className='info'>
            <p><span className='count'>1.</span> We will use your Facebook Profile to add you to our messenger group of this "{courseData.name}".</p>
            <div className='wrapper'>
              <div className='icon'>
                <span className='fab fa-facebook'></span>
              </div>
              <div className='detail'>{userData.facebookLink === ''? <Link to='/edit-profile'>Add Facebook Profile Link</Link> : userData.facebookLink}</div>
            </div>
          </div>

          <div className='info'>
            <p><span className='count'>2.</span> We will use this mobile number to call you for the enroll confirmation.</p>
            <div className='wrapper'>
              <div className='icon'>
                <span className='fas fa-phone-alt'></span>
              </div>
              <div className='detail'>{userData.mobileNumber === ''? <Link to='/edit-profile'>Add Mobile Number</Link> : userData.mobileNumber}</div>
            </div>
          </div>

          <div className='info'>
            <p><span className='count'>3.</span> We will use this email address send you important notices.</p>
            <div className='wrapper'>
              <div className='icon'>
                <span className='fas fa-envelope'></span>
              </div>
              <div className='detail'>{userData.email}</div>
            </div>
          </div>
        </section>

        <button className='btn_primary br_10 w-100 bg-2 bx_shadow' style={{height: '45px', lineHeight: '47px', marginTop: '30px'}}>Confirm Enroll</button>
        
      </div>
    </div>
  )
}
